// removed by extract-text-webpack-plugin
module.exports = {"outerContainer":"src-components-Messages-styles-__PendingMediaMessage__outerContainer--1j0jM","image":"src-components-Messages-styles-__PendingMediaMessage__image--1FbVI","previewText":"src-components-Messages-styles-__PendingMediaMessage__previewText--2Ct_A","buttonsContainer":"src-components-Messages-styles-__PendingMediaMessage__buttonsContainer--1l018","button":"src-components-Messages-styles-__PendingMediaMessage__button--1FBcy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/styles/PendingMediaMessage.css
// module id = 1963
// module chunks = 0